import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=38430d6f&scoped=true"
import script from "./perfil.vue?vue&type=script&lang=js"
export * from "./perfil.vue?vue&type=script&lang=js"
import style0 from "./perfil.vue?vue&type=style&index=0&id=38430d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38430d6f",
  null
  
)

export default component.exports